import React from "react";

const JsonFormatter = ({ data }) => {
  if (!data) return <p style={{ color: "#ccc" }}>Generating AI Insights</p>;

  return (
    <div
      style={{
        maxWidth: "800px",
        margin: "2rem auto",
        padding: "2rem",
        backgroundColor: "#0f172a",
        color: "#f1f5f9",
        borderRadius: "1rem",
        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.5)",
        textAlign: "center",
      }}
    >
      <h2
        style={{
          fontSize: "2rem",
          fontWeight: "bold",
          color: "#38bdf8",
          marginBottom: "1.5rem",
        }}
      >
        🍎 Health Overview
      </h2>
      <p>{data}</p>
    </div>
  );
};

export default JsonFormatter;
